export default function PlayChatLog({ messages, logRef, emptyText = 'No conversation yet.', hasMessages = messages.length > 0, speakerLabel = label => label, renderMessageActions, historyControl }) {
  return <div className="play-chat-region">
    <div className="explore-chat-log play-chat-log" ref={logRef}>
      {historyControl}
      {!hasMessages ? <div className="explore-chat-empty">{emptyText}</div>
        : messages.map((message, index) => <div key={`${message.role}-${index}`} className={`explore-chat-entry explore-chat-entry-${message.role}`}>
          {message.role === 'user' ? <strong>You</strong> : null}
          {message.role === 'npc' ? <strong>{speakerLabel(message.speaker)}</strong> : null}
          {message.role === 'system' ? <strong>System</strong> : null}
          <div className="explore-chat-content">{message.content}</div>
          {renderMessageActions?.(message)}
        </div>)}
    </div>
  </div>;
}
